site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length === 0) return;
		$(window).load(function() {
			site.maxHeight.setHeight(selector);
		});
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	}
};
